import { render, staticRenderFns } from "./combine-contact-sources-gray.svg?vue&type=template&id=1f7d9fa8"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports